export const MainURL = { 
    HostUrl: 'https://signup.qnvert.com/api', 
    // HostUrl: 'http://localhost:8000/api', 
    imageUrl: '/assets'
  }
 

  